import { createSlice } from "@reduxjs/toolkit";

//Initial Value of Slice
const initialState = {
    List: [
        {
            Id : "Primary-1",
        }
    ]
}

//Action of Slice
const refundPolicySlice = createSlice({
    name: "RefundPolicy",
    initialState,
    reducers: {}
})

//Export of Slice
export const { } = refundPolicySlice.actions;
export default refundPolicySlice.reducer;